<template>
	<label :class="{ full: full }">
		{{ $t("components.subscription_form." + source + '.' + param) }}<br>
		<input
			v-if="type === 'input'"

			:type="inputAttr.type"
			class="form-control"
			:value='subscriptionStore.subscriptionParams[param]'
			@input="updateSubscriptionParam({ param: param, value: $event.target.value })"
			:autocomplete="inputAttr.autocomplete"
			:maxlength="inputAttr.maxlength"
			:title="inputAttr.title"
			:placeholder="inputAttr.placeholder"
			:disabled="$root.source === 'enel'"
		>

		<select
			v-if="type === 'select'"

			class="form-control"
			@change="$emit('onChange', $event)"
			:value="subscriptionStore.subscriptionParams[param]"
		>
			<option
				value=""
				v-html="inputAttr.placeholder"
			/>
			<option
				v-for="(option, index) in options"
				:value="option"
				:selected="option === subscriptionStore.subscriptionParams[param]"
				:key="index"
				v-html="option"
			/>

		</select>
 
		<template v-if="type === 'vue-phone'">	

			<!-- TODO: autocomplete for phone -->

			<vue-phone-number-input
				:class="{ 'is-not-valid': !isPhoneValid }"
				v-model="phoneModel"
				@update="updatePhone"
				
				default-country-code='IT'
				required
				no-flags
				no-validator-state
				color="no"
				:translations="{
					countrySelectorLabel: 'Codice',
					countrySelectorError: 'countrySelectorError',
					phoneNumberLabel: '',
					example: 'Es.:'
				}"
			/>
			<div v-if="!isPhoneValid" class="red-text info-small-normal">
				Numero di telefono non valido
			</div>
		</template>
	</label>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

import { subscriptionStore } from '../../store/subscriptionStore'

export default {
	data () {
		return {
			subscriptionStore: subscriptionStore.state,
			// phoneModel: subscriptionStore.state.subscriptionParams.telephone.substr(3),
			isPhoneValid: true
		}
	},

	components: {
		VuePhoneNumberInput
	},

	props: {
		type: {
			type: String,
			default: 'input'
		},
		param: {
			type: String,
			default: null
		},
		inputAttr: {
			type: Object,
			default () {
				return {}
			}
		},
		options: {
			type: Array,
			default () {
				return []
			}
		},
		full: {
			type: Boolean,
			default: false
		},
		source: {
			type: String,
			default: 'default'
		}
	},

	methods: {
		updateSubscriptionParam (vars) {
			subscriptionStore.updateSubscriptionParam(vars)
		},

		updatePhone (payload) {
			var str = this.subscriptionStore.subscriptionParams['telephone']

			// clean if not valid so it won't pass api validation
			if (!payload.isValid) {
				this.isPhoneValid = false

				this.updateSubscriptionParam({ param: 'telephone', value: null })
			} else {
				this.isPhoneValid = true
				var str = payload.formatInternational
				var code = str.substr(0,str.indexOf(' '))
				var codeOnlyNumbers = code.substr(1)
				var codeZeroFormatted = ('000' + codeOnlyNumbers).substr(-3,3) //short and sweet 
				var phone = str.substr(str.indexOf(' ')+1).replace(/\s+/g, '')
				this.updateSubscriptionParam({ param: 'telephone', value: codeZeroFormatted + phone })
			}

			if (!this.phoneModel) {
				this.isPhoneValid = true
			}
		}
	},

	mounted () {
		if (this.type === 'vue-phone') {
			var phone = this.subscriptionStore.subscriptionParams.telephone.substr(3)
			var code = this.subscriptionStore.subscriptionParams.telephone.substr(0,3)
			// this.phoneModel = phone
		} 
	}
}

</script>

<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.vue-phone-number-input {
	font-family: inherit;
}

.vue-phone-number-input >>> .select-country-container input,
.vue-phone-number-input >>> .flex-1 .input-phone-number input {
	margin: 0 0 10px 0;
    padding: 6px 15px;
    border: 2px solid #EDEDED;
    background: rgba(255, 255, 255, 0.1);
    color: #575A5C;
    width: 100%;
    outline: none;
    height: 36px;
    border-radius: 4px;
    font-family: inherit;
}

.vue-phone-number-input >>> .select-country-container {
	flex: 0 0 80px;
    width: 80px;
    min-width: 80px;
    max-width: 80px;
}

.vue-phone-number-input >>> .country-selector .field-input,
.vue-phone-number-input >>> .flex-1 .input-phone-number .field-input,
.vue-phone-number-input >>> .flex-1 .input-phone-number.has-value .field-input {
	font-size: inherit;
	padding: 6px 15px;
}

.vue-phone-number-input >>> .country-selector .country-selector-arrow {
	top: calc(50% - 16px);
}

.vue-phone-number-input >>> .country-selector label, 
.vue-phone-number-input >>> .input-phone-number label {
	display: none;
}

.vue-phone-number-input >>> .field.vue-input-ui.is-focused .field-input {
	border-color: #EDEDED;
}

.vue-phone-number-input >>> .field.vue-input-ui .field-input:not(.textarea),
.vue-phone-number-input >>> .field-input:not(.textarea) {
	height: calc(2.25rem + 2px);
    min-height: calc(2.25rem + 2px);
}

.vue-phone-number-input >>> .country-selector .country-list-item.selected {
	color: inherit;
}
</style>
